import { Injectable } from '@angular/core';
import Enums from '../../utils/enums';
// const json = require('./../assets/fonts/selection.json');
@Injectable()
export class SettingsService {

    // // Indisio
    // serverMain = 'http://194.169.209.70:8900/api/';
    // serverNomenclator = 'http://194.169.209.70:8901/api/';
    // serverAzure = 'http://194.169.209.70:8903/api/';

    // Andrei
    // serverMain = 'http://192.168.20.138:8900/api/';
    // serverNomenclator = 'http://192.168.20.138:8901/api/';
    // serverAzure = 'http://192.168.20.138:8903/api/';

    // PRODUCTION (AZURE) !!!!!
    serverMain = 'https://admin.uppark.io:8900/api/';
    serverNomenclator = 'https://admin.uppark.io:8901/api/';
    serverAzure = 'https://admin.uppark.io:8903/api/';

    // AZURE TEST
    // serverMain = 'https://testenv.uppark.io:8900/api/';
    // serverNomenclator = 'https://testenv.uppark.io:8901/api/';
    // serverAzure = 'https://testenv.uppark.io:8903/api/';

    //dev 2
    // serverMain = 'http://194.169.209.101:8900/api/';
    // serverNomenclator = 'http://194.169.209.101:8901/api/';
    // serverAzure = 'http://194.169.209.101:8903/api/';

    //Alina
    // serverMain = 'http://192.168.20.142:8900/api/';
    // serverNomenclator = 'http://192.168.20.142:8901/api/';
    // serverAzure = 'http://192.168.20.142:8903/api/';

    currentFinesListPage: number = null;
    currentFinesDateRange: any = {
        startDate: null,
        endDate: null,
    };

    currentVehicleExceptionsListPage: number = null;

    constructor() {
    }

    PARKING_TYPES(parkingType) {
        switch (parkingType) {
            case Enums.eParkingType.Public:
                return './../../assets/pin/off_street1.png';

            case Enums.eParkingType.Private:
                return './../../assets/pin/private.png';
        }
    }

    PARKING_TYPES_CLICKED(parkingType) {
        switch (parkingType) {
            case Enums.eParkingType.Public:
                return './../../assets/pin/off_street.png';

            case Enums.eParkingType.Private:
                return './../../assets/pin/private_clicked.png';
        }
    }

    TARIFF_TYPE_BY_ID(tariffID) {
        switch (tariffID) {
            case Enums.eTariffType.Standard:
                return '/ HOUR';
            case Enums.eTariffType.PerDay:
                return '/ DAY';
        }
    }

    CURRENCY_TYPES(currencyID: number): string {
        switch (currencyID) {
            case Enums.eCurrencyType.RON:
                return 'RON';
            case Enums.eCurrencyType.EUR:
                return 'EUR';
            case Enums.eCurrencyType.USD:
                return 'USD';
        }
    }

    PAYMENT_METHOD_TYPE_ICON(paymentMethodTypeID: number): string {
        switch (paymentMethodTypeID) {
            case Enums.ePaymentMethodType.Cash:
                return './../../assets/payments/ic_payment_cash.png';
            case Enums.ePaymentMethodType.Card:
                return './../../assets/payments/ic_payment_card.png';
            case Enums.ePaymentMethodType.SMS:
                return './../../assets/payments/ic_payment_sms.png';
            default:
                return './../../assets/payments/ic_payment_sms.png';
        }
    }

    PAYMENT_METHOD_TYPE(paymentMethodTypeID: number) {
        switch (paymentMethodTypeID) {
            case Enums.ePaymentMethodType.Cash:
                return 'Cash';
            case Enums.ePaymentMethodType.Card:
                return 'Card';
            case Enums.ePaymentMethodType.SMS:
                return 'SMS';
            default:
                return 'SMS';
        }
    }

    PAYMENT_TYPE(paymentTypeID) {
        switch (paymentTypeID) {
            case Enums.ePaymentType.Park:
                return 'Park';
            case Enums.ePaymentType.Fine:
                return 'Fine';
        }
    }

    CARD_TYPES(cardTypeID) {
        switch (cardTypeID) {
            case Enums.eCardType.Unrecognized:
                return 'Unrecognized';
            case Enums.eCardType.Ambiguous:
                return 'Ambiguous';
            case Enums.eCardType.Amex:
                return 'Amex';
            case Enums.eCardType.JCB:
                return 'JCB';
            case Enums.eCardType.Visa:
                return 'Visa';
            case Enums.eCardType.Mastercard:
                return 'Mastercard';
            case Enums.eCardType.Discover:
                return 'Discover';
        }
    }

    DAY_OF_WEEK_BY_ID(dayOfWeekID) {
        switch (dayOfWeekID) {
            case null:
                return 'Luni - Duminica';
            case Enums.eDayOfWeek.Monday:
                return 'Luni';
            case Enums.eDayOfWeek.Tuesday:
                return 'Marti';
            case Enums.eDayOfWeek.Wednesday:
                return 'Miercuri';
            case Enums.eDayOfWeek.Thursday:
                return 'joi';
            case Enums.eDayOfWeek.Friday:
                return 'Vineri';
            case Enums.eDayOfWeek.Saturday:
                return 'Sambata';
            case Enums.eDayOfWeek.Sunday:
                return 'Duminica';
        }
    }

    LOGIN_ROLE(roleId: number) {
        switch (roleId) {
            case Enums.eRole.Administrator:
                return 'Administrator';
            case Enums.eRole.SuperAdministrator:
                return 'SuperAdministrator';
            case Enums.eRole.Client:
                return 'Client';
            case Enums.eRole.Supervisor:
                return 'Supervisor';
            case Enums.eRole.Hotel:
                return 'Hotel';
            case Enums.eRole.Police:
                return 'Police';
            case Enums.eRole.EveHandler:
                return 'EveHandler';
        }
    }

    LANGUAGE() {
        const language: string = localStorage.getItem('language');

        if (language) {
            return language;
        } else {
            return 'ro';
        }
    }

    SET_LANGUAGE(language: string) {
        localStorage.setItem('language', language);
    }
}
